<template>
  <div id="tab-bar">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TabBar",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style scoped>
body,
html {
  padding: 0;
  margin: 0;
}
#tab-bar {
  display: flex;
  background-color: #f6f6f6;
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  box-shadow: 0px -1px 1px rgba(100, 100, 100, 0.2);
  border-top: 2px solid #ffdf89;
  border-bottom: 2px solid #ffdf89;
  background-color: rgba(0, 0, 0, 0.6);
}
</style>